"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientOnlyAuthenticationContextProvider = exports.AuthenticationContextProvider = exports.useAuthenticationContext = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("react");
var react_3 = require("react");
var AuthenticationContext = React.createContext(undefined);
var useAuthenticationContext = function () {
    var auth = React.useContext(AuthenticationContext);
    if (!auth) {
        throw new Error("useAuthenticationContext() must be used within a <AuthenticationContextProvider> component");
    }
    return auth;
};
exports.useAuthenticationContext = useAuthenticationContext;
var AuthenticationContextProvider = function (_a) {
    var children = _a.children, value = __rest(_a, ["children"]);
    return React.createElement(AuthenticationContext.Provider, { value: value }, children);
};
exports.AuthenticationContextProvider = AuthenticationContextProvider;
var ClientOnlyAuthenticationContextProvider = function (_a) {
    var children = _a.children;
    var _b = __read((0, react_1.useState)(fetchClientSideClerkContext), 2), value = _b[0], setValue = _b[1];
    var currentUserId = (0, react_2.useRef)("");
    (0, react_3.useEffect)(function () {
        return Clerk.addListener(function (_a) {
            var _b;
            var user = _a.user;
            if (currentUserId.current !== (user === null || user === void 0 ? void 0 : user.externalId)) {
                currentUserId.current = (_b = user === null || user === void 0 ? void 0 : user.externalId) !== null && _b !== void 0 ? _b : "";
                setValue(fetchClientSideClerkContext());
            }
        });
    }, []);
    return React.createElement(AuthenticationContext.Provider, { value: value }, children);
};
exports.ClientOnlyAuthenticationContextProvider = ClientOnlyAuthenticationContextProvider;
var fetchClientSideClerkContext = function () {
    var _a, _b, _c;
    return {
        isInitialized: Clerk.isReady(),
        isSignedIn: !!Clerk.user,
        user: Clerk.user
            ? {
                emailAddress: (_a = Clerk.user.primaryEmailAddress) === null || _a === void 0 ? void 0 : _a.emailAddress,
                profileImageUrl: (_b = Clerk.user.profileImageUrl) !== null && _b !== void 0 ? _b : "",
                fullName: (_c = Clerk.user.fullName) !== null && _c !== void 0 ? _c : "",
            }
            : undefined,
        getToken: Clerk.session ? Clerk.session.getToken : function () { return Promise.resolve(null); },
        signOut: Clerk.signOut,
    };
};
